import { cleanUpHtml } from './html';

function addNumbers(index: number, useBoldNumbers: boolean): string {
  return useBoldNumbers ? `<strong>${index}.</strong>` : `${index}.`;
}

function addNumberIntoLeadingNoWrap(
  referenceHtml: string,
  numberPrefix: string,
): string {
  const startsWithNoWrap = /^\s*<span\b[^>]*\bstyle="[^"]*\bwhite-space\s*:\s*nowrap\b[^"]*"[^>]*>/i;

  if (!startsWithNoWrap.test(referenceHtml)) {
    return referenceHtml;
  }

  return referenceHtml.replace(startsWithNoWrap, match => `${match}${numberPrefix}`);
}

export function getReferenceHtmlAsString(
  index: number,
  reference: string,
  useBoldNumbers = false,
  useNumbers = true,
): string {
  const sanitizedHtml = cleanUpHtml(reference);

  if (!useNumbers) {
    return sanitizedHtml;
  }

  const numberPrefix = `${addNumbers(index, useBoldNumbers)}&nbsp;`;
  const normalizedHtml = addNumberIntoLeadingNoWrap(sanitizedHtml, numberPrefix);

  return normalizedHtml === sanitizedHtml
    ? `${numberPrefix}${sanitizedHtml}`
    : normalizedHtml;
}
